import { Component, computed, inject } from '@angular/core';
import { ToastService } from '@services/toast.service';

@Component({
  imports: [],
  selector: 'app-toast',
  styleUrl: './toast.component.scss',
  templateUrl: './toast.component.html',
})
export class ToastComponent {
  private toastService = inject(ToastService);
  action = computed(() => this.currentToast()?.action ?? null);
  currentToast = this.toastService.getCurrentToast();
  icon = computed(() => this.currentToast()?.icon || '');
  message = computed(() => this.currentToast()?.message || '');
  show = computed(() => this.currentToast()?.status === 'show');
  title = computed(() => this.currentToast()?.title || '');
  type = computed(() => this.currentToast()?.type || 'info');

  close(): void {
    this.toastService.hideCurrentToast();
  }

  protected triggerAction(event: Event): void {
    event.stopPropagation();
    const action = this.currentToast()?.action;
    this.close();
    action?.handler();
  }
}
